<div class="row pallets-container">
    <div class="col-lg-12">
        <div class="pallets-panel">
            <ng-container *ngFor="let pallet of packagePallets">
                <app-pallet [pallet]="pallet"></app-pallet>
            </ng-container>
        </div>
    </div>
</div>
